'use es6';

import { Record } from 'immutable';
import MABContentInfo from './MABContentInfo';
import { RequestStatus } from '../constants/base';
const DEFAULTS = {
  status: RequestStatus.UNINITIALIZED,
  winnerContent: new MABContentInfo()
};
export default class MABEndTest extends Record(DEFAULTS) {
  static fromJS(data) {
    return new MABEndTest({
      status: RequestStatus.SUCCEEDED,
      winnerContent: MABContentInfo.fromJS(data)
    });
  }
}